export const exData = [
	{
		id: 2,
		name: 'Full Stack JavaScript Freelancer',
		type: 'Freelance',
		about: {
			date: 'January 2020 - Present',
			info: 'I have gained valuable experience as a freelancer by working on diverse web development projects. Collaborating with clients from various industries, I have successfully brought their ideas to life and helped them achieve their online goals. My work involved full-stack web development, from building websites from scratch to fixing errors and optimizing performance.',
			subTitle: 'Notable Projects',
			list: [
				'Built a portfolio website for a painter to showcase their artwork',
				'Developed a professional website for a small business agency',
				'Created a fully functional eCommerce store with a custom design and user-friendly interface',
			],
		},
		moreInfo: {
			title: '',
			text: '',
		},
	},
	{
		id: 3,
		name: 'Frontend Developer',
		type: 'Internship',
		about: {
			date: 'September 2019 - October 2020',
			info: 'As a Frontend Intern at Progesse Company, I worked on various web development projects, enhancing my skills in modern frontend technologies.',
			subTitle: 'My Duties in This Internship',
			list: [
				'Completed multiple projects categorized as basic and golden, successfully delivering 4 projects involving HTML, CSS, JavaScript, React, and API integration.',
				'Maintained a GitHub repository ("Chaker_135") for all projects, improving my proficiency in version control and collaborative development.',
				'Updated and leveraged my LinkedIn profile to showcase my internship status and completed projects, enhancing visibility to recruiters and potential employers.',
			],
		},
		moreInfo: {
			title:
				'Projects I Worked On: <a style="color: #9149c4;" href="https://github.com/cheker-135/canningFood-mern-app-client" target="_blank" rel="noreferrer" alt="canning-food">CanningFood-MERN App</a>, <a style="color: #9149c4;" href="https://github.com/cheker-135/LaunchEaisiness-App-client" target="_blank" rel="noreferrer" alt="Online Business Creation">Online Business Creation Platform</a>, <a style="color: #9149c4;" href="https://github.com/cheker-135/project-manger-front" target="_blank" rel="noreferrer" alt="Project Manager App">Project Management System</a>',
		},
	},
];
